module.exports = __webpack_public_path__ + "img/1x.c0a4bee.jpg";